import { render, staticRenderFns } from "./BlockViewer.vue?vue&type=template&id=f3ef9c94"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockViewer.vue?vue&type=style&index=0&id=f3ef9c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports